import { useRouterState } from "@tanstack/react-router";

export const useActiveParent = (prefixes: string[]) => {
  const pathname = useRouterState().location.pathname;
  const firstSegment = pathname?.split("/")[1];
  return prefixes?.includes(firstSegment);
};
